/**
 * WelcomeKitBanner — Shown to employees who have a pending policy acceptance.
 * Appears as a dismissible sticky banner below the top header until accepted.
 */
import React, { useEffect, useState } from 'react';
import { Alert, Button, Box } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../api/axios';

export default function WelcomeKitBanner() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [pending, setPending] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!user) return;
    // Don't check on the acceptance page itself
    if (location.pathname === '/welcome-acceptance') return;

    api.get('/welcome-kits/my')
      .then(r => {
        if (r.data && r.data.status === 'pending') setPending(true);
      })
      .catch(() => {});
  }, [user, location.pathname]);

  if (!pending || dismissed || location.pathname === '/welcome-acceptance') return null;

  return (
    <Alert
      severity="warning"
      sx={{ borderRadius: 0, '& .MuiAlert-message': { display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between', gap: 2 } }}
      onClose={() => setDismissed(true)}
    >
      <Box>
        <strong>Action Required:</strong> You have pending ICT policy documents that require your acceptance.
        You will receive daily email reminders until completed.
      </Box>
      <Button
        size="small"
        variant="outlined"
        color="warning"
        onClick={() => navigate('/welcome-acceptance')}
        sx={{ whiteSpace: 'nowrap', flexShrink: 0 }}
      >
        Review &amp; Accept Now
      </Button>
    </Alert>
  );
}
